import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

import { cn } from '@components/../lib/utils'

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'relative h-[18px] w-[18px] shrink-0 rounded-full border-0 transition-colors',
        'data-[state=unchecked]:bg-[#D1D5D8]',
        'data-[state=checked]:bg-[#1F6FEB]',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1F6FEB]/40 focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className='absolute inset-0 flex items-center justify-center'>
        <span className='relative flex h-[12px] w-[12px] items-center justify-center rounded-full bg-white'>
          <span className='block h-[6px] w-[6px] rounded-full bg-[#1F6FEB]' />
        </span>
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
